// store/slices/categoriesSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProductCategory } from "../../types/types";

interface CategoriesState {
  categories: ProductCategory[];
  loading: boolean;
  error: string | null;
}

const initialState: CategoriesState = {
  categories: [] as ProductCategory[],
  loading: false,
  error: null,
};

// Async thunk для получения категорий
export const fetchCategories = createAsyncThunk(
  "categories/fetch",
  async () => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/product_categories/`);
    if (!response.ok) {
      throw new Error("Ошибка при получении категорий");
    }
    const a = response.json();
    return a;
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.loading = false;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Ошибка";
      });
  },
});

// export const selectCategories = (state: CategoriesState) => state.categories;
export const selectCategories = (state: { categories: CategoriesState }) =>
  state.categories.categories;

export const selectLoadingCategories = (state: CategoriesState) =>
  state.loading;

export const selectErrorCategories = (state: CategoriesState) => state.error;

export default categoriesSlice.reducer;
